// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mapping tab, matched to incyia-app-redesign (DASH_TAB === 'mapping').
   html { zoom: 0.8 }, so every length is the HTML value × 1.25.
   On screen that is the same size as the redesign file. */
.dmap {
  width: 100%;
  color: #0f172a;
}

.dmap-body {
  position: relative;
  min-height: 350px;
}

.dmap-body.is-loading .dmap-kpi-grid,
.dmap-body.is-loading .dmap-card {
  opacity: 0.35;
  pointer-events: none;
  filter: saturate(0.7);
}

.dmap-loader {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  background: rgba(241, 244, 250, 0.55);
  backdrop-filter: blur(1px);
  font-size: 16.25px;
  font-weight: 500;
  color: #5b6b87;
}

.dmap-spinner {
  width: 35px;
  height: 35px;
  border: 2.5px solid #dee4f0;
  border-top-color: #1fbfa3;
  border-radius: 99px;
  animation: dmap-spin 0.7s linear infinite;
}

@keyframes dmap-spin {
  to {
    transform: rotate(360deg);
  }
}

.dmap-empty--tall {
  min-height: 225px;
}

.dmap-eyebrow {
  font-size: 13.125px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #8b99b4;
}

.dmap-fw-switch {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.dmap-fw-switch > .dmap-eyebrow {
  margin-right: 2.5px;
}

.dmap-chip {
  display: inline-flex;
  align-items: center;
  gap: 7.5px;
  height: 37.5px;
  padding: 0 13.75px;
  border-radius: 99px;
  border: 1px solid #dee4f0;
  background: #fff;
  font-size: 15.625px;
  color: #5b6b87;
  cursor: pointer;
  transition: all 0.14s;
  width: auto !important;
  line-height: 1;
}

.dmap-chip:hover {
  border-color: #8b99b4;
  color: #0f172a;
}

.dmap-chip.on {
  background: #e2f7f2;
  border-color: transparent;
  color: #0e8271;
  font-weight: 500;
}

.dmap-chip--ghost {
  background: #fff;
}

.dmap-chip--ghost svg {
  width: 17.5px;
  height: 17.5px;
}

.dmap-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
  align-items: stretch;
}

.dmap-kpi {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12.5px;
  padding: 20px 22.5px;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.05),
    0 10px 28px -20px rgba(0, 20, 109, 0.4);
  overflow: hidden;
  text-align: left;
  width: 100%;
}

/* Same height trick as the Missions priority cards: siblings sit 20px
   lower inside a stretched row, so the first card is taller. */
.dmap-kpi + .dmap-kpi {
  margin-top: 20px;
}

.dmap-kpi .dmap-eyebrow {
  margin-bottom: 10px;
}

.dmap-kpi-v {
  margin: 0;
  font-size: 35px;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.1;
  color: #0f172a;
}

.dmap-kpi-v--teal {
  color: #0e8271;
}

.dmap-kpi-v--amber {
  color: #b0730f;
}

.dmap-kpi-of {
  font-size: 18.75px;
  font-weight: 400;
  color: #5b6b87;
}

.dmap-kpi-d {
  margin-top: 6.25px;
  font-size: 15.625px;
  color: #5b6b87;
  line-height: 1.5;
}

.dmap-bar-track {
  height: 10px;
  border-radius: 99px;
  background: #eaeff7;
  overflow: hidden;
  display: flex;
  margin-top: 12.5px;
}

.dmap-bar-track span {
  height: 100%;
  display: block;
}

.dmap-card {
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12.5px;
  box-shadow:
    0 1.25px 2.5px rgba(15, 23, 42, 0.05),
    0 12.5px 35px -25px rgba(0, 20, 109, 0.4);
  overflow: hidden;
}

.dmap-toolbar {
  display: flex;
  align-items: center;
  gap: 12.5px;
  flex-wrap: wrap;
  padding: 15px 20px;
  border-bottom: 1px solid #eaeff7;
  background: #fff;
}

.dmap-search {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 42.5px;
  padding: 0 13.75px;
  background: #f7f9fd;
  border: 1px solid #dee4f0;
  border-radius: 10px;
  min-width: 275px;
  flex: 1 1;
  max-width: 400px;
}

.dmap-search svg {
  width: 17.5px;
  height: 17.5px;
  color: #8b99b4;
  flex: none;
}

.dmap-search input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 16.25px;
  background: transparent;
  color: #0f172a;
  font-family: 'IBM Plex Sans', system-ui, sans-serif;
}

.dmap-search input::placeholder {
  color: #8b99b4;
}

.dmap-count-note {
  margin-left: auto;
  font-size: 15.625px;
  color: #5b6b87;
}

.dmap-table-wrap {
  overflow: auto;
}

.dmap-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}

.dmap-table thead th {
  font-size: 13.125px;
  font-weight: 600;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #8b99b4;
  text-align: left;
  padding: 13.75px 20px;
  background: #f7f9fd;
  border-bottom: 1px solid #dee4f0;
  position: sticky;
  top: 0;
}

.dmap-table thead th:last-child {
  text-align: right;
}

.dmap-table tbody td {
  padding: 16.25px 20px;
  border-bottom: 1px solid #eaeff7;
  font-size: 16.875px;
  vertical-align: middle;
  color: #0f172a;
}

.dmap-table tbody tr {
  cursor: pointer;
  transition: background 0.12s;
}

.dmap-table tbody tr:hover {
  background: #f7f9fd;
}

.dmap-table tbody tr:last-child td {
  border-bottom: none;
}

.dmap-label {
  white-space: normal;
  min-width: 350px;
  font-weight: 500;
  color: #0f172a;
  vertical-align: middle;
}

.dmap-label .incyia-desc,
.dmap-label .incyia-desc--primary {
  display: block;
  -webkit-line-clamp: unset;
  line-clamp: unset;
  -webkit-box-orient: unset;
  overflow: visible;
  max-width: none;
  color: #0f172a;
  font-weight: 500;
  font-size: 16.875px !important;
  line-height: 1.45;
  cursor: pointer;
  text-decoration: none;
}

.dmap-table tbody tr:hover .dmap-label,
.dmap-table tbody tr:hover .dmap-label .incyia-desc,
.dmap-table tbody tr:hover .dmap-label .incyia-desc--primary {
  background: transparent;
  color: #0f172a;
  text-decoration: none;
}

.dmap-mono {
  font-size: 16.875px;
  color: #0f172a;
}

.dmap-table td:nth-child(2) .dmap-mono {
  font-size: 15.625px;
}

.dmap-map-cell {
  display: flex;
  align-items: center;
  gap: 11.25px;
  min-width: 212px;
}

.dmap-map-frac {
  font-size: 15px;
  color: #5b6b87;
}

.dmap-bar-track--sm {
  width: 110px;
  margin-top: 0;
  flex: none;
}

.dmap-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 37.5px;
  padding: 0 12.5px;
  border-radius: 10px;
  border: 1px solid #dee4f0;
  background: #fff;
  box-shadow: none;
  font-size: 15.625px;
  font-weight: 500;
  color: #0f172a;
  cursor: pointer;
  width: auto !important;
  line-height: 1;
  transition: background 0.14s, border-color 0.14s;
}

.dmap-btn:hover {
  background: #f7f9fd;
  border-color: #8b99b4;
}

.dmap-pager {
  display: flex;
  align-items: center;
  gap: 12.5px;
  padding: 15px 20px;
  border-top: 1px solid #eaeff7;
  flex-wrap: wrap;
}

.dmap-pager-info {
  margin-left: 0;
  font-size: 15.625px;
  color: #5b6b87;
}

.dmap-pager .dmap-btn {
  margin-left: auto;
}

.dmap-empty {
  padding: 50px 20px;
  text-align: center;
  color: #8b99b4;
  font-size: 16.875px;
}

@media (max-width: 1100px) {
  .dmap-kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .dmap-kpi-grid {
    grid-template-columns: 1fr;
  }

  .dmap-count-note {
    margin-left: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/mission/components/DashboardMappingControls.css"],"names":[],"mappings":"AAAA;;0DAE0D;AAC1D;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB;;2CAEyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;+DAC+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB;;6CAE2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;EAGE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF","sourcesContent":["/* Mapping tab, matched to incyia-app-redesign (DASH_TAB === 'mapping').\n   html { zoom: 0.8 }, so every length is the HTML value × 1.25.\n   On screen that is the same size as the redesign file. */\n.dmap {\n  width: 100%;\n  color: #0f172a;\n}\n\n.dmap-body {\n  position: relative;\n  min-height: 350px;\n}\n\n.dmap-body.is-loading .dmap-kpi-grid,\n.dmap-body.is-loading .dmap-card {\n  opacity: 0.35;\n  pointer-events: none;\n  filter: saturate(0.7);\n}\n\n.dmap-loader {\n  position: absolute;\n  inset: 0;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  background: rgba(241, 244, 250, 0.55);\n  backdrop-filter: blur(1px);\n  font-size: 16.25px;\n  font-weight: 500;\n  color: #5b6b87;\n}\n\n.dmap-spinner {\n  width: 35px;\n  height: 35px;\n  border: 2.5px solid #dee4f0;\n  border-top-color: #1fbfa3;\n  border-radius: 99px;\n  animation: dmap-spin 0.7s linear infinite;\n}\n\n@keyframes dmap-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.dmap-empty--tall {\n  min-height: 225px;\n}\n\n.dmap-eyebrow {\n  font-size: 13.125px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #8b99b4;\n}\n\n.dmap-fw-switch {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.dmap-fw-switch > .dmap-eyebrow {\n  margin-right: 2.5px;\n}\n\n.dmap-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7.5px;\n  height: 37.5px;\n  padding: 0 13.75px;\n  border-radius: 99px;\n  border: 1px solid #dee4f0;\n  background: #fff;\n  font-size: 15.625px;\n  color: #5b6b87;\n  cursor: pointer;\n  transition: all 0.14s;\n  width: auto !important;\n  line-height: 1;\n}\n\n.dmap-chip:hover {\n  border-color: #8b99b4;\n  color: #0f172a;\n}\n\n.dmap-chip.on {\n  background: #e2f7f2;\n  border-color: transparent;\n  color: #0e8271;\n  font-weight: 500;\n}\n\n.dmap-chip--ghost {\n  background: #fff;\n}\n\n.dmap-chip--ghost svg {\n  width: 17.5px;\n  height: 17.5px;\n}\n\n.dmap-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n  align-items: stretch;\n}\n\n.dmap-kpi {\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12.5px;\n  padding: 20px 22.5px;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.05),\n    0 10px 28px -20px rgba(0, 20, 109, 0.4);\n  overflow: hidden;\n  text-align: left;\n  width: 100%;\n}\n\n/* Same height trick as the Missions priority cards: siblings sit 20px\n   lower inside a stretched row, so the first card is taller. */\n.dmap-kpi + .dmap-kpi {\n  margin-top: 20px;\n}\n\n.dmap-kpi .dmap-eyebrow {\n  margin-bottom: 10px;\n}\n\n.dmap-kpi-v {\n  margin: 0;\n  font-size: 35px;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n  color: #0f172a;\n}\n\n.dmap-kpi-v--teal {\n  color: #0e8271;\n}\n\n.dmap-kpi-v--amber {\n  color: #b0730f;\n}\n\n.dmap-kpi-of {\n  font-size: 18.75px;\n  font-weight: 400;\n  color: #5b6b87;\n}\n\n.dmap-kpi-d {\n  margin-top: 6.25px;\n  font-size: 15.625px;\n  color: #5b6b87;\n  line-height: 1.5;\n}\n\n.dmap-bar-track {\n  height: 10px;\n  border-radius: 99px;\n  background: #eaeff7;\n  overflow: hidden;\n  display: flex;\n  margin-top: 12.5px;\n}\n\n.dmap-bar-track span {\n  height: 100%;\n  display: block;\n}\n\n.dmap-card {\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12.5px;\n  box-shadow:\n    0 1.25px 2.5px rgba(15, 23, 42, 0.05),\n    0 12.5px 35px -25px rgba(0, 20, 109, 0.4);\n  overflow: hidden;\n}\n\n.dmap-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12.5px;\n  flex-wrap: wrap;\n  padding: 15px 20px;\n  border-bottom: 1px solid #eaeff7;\n  background: #fff;\n}\n\n.dmap-search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 42.5px;\n  padding: 0 13.75px;\n  background: #f7f9fd;\n  border: 1px solid #dee4f0;\n  border-radius: 10px;\n  min-width: 275px;\n  flex: 1;\n  max-width: 400px;\n}\n\n.dmap-search svg {\n  width: 17.5px;\n  height: 17.5px;\n  color: #8b99b4;\n  flex: none;\n}\n\n.dmap-search input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 16.25px;\n  background: transparent;\n  color: #0f172a;\n  font-family: 'IBM Plex Sans', system-ui, sans-serif;\n}\n\n.dmap-search input::placeholder {\n  color: #8b99b4;\n}\n\n.dmap-count-note {\n  margin-left: auto;\n  font-size: 15.625px;\n  color: #5b6b87;\n}\n\n.dmap-table-wrap {\n  overflow: auto;\n}\n\n.dmap-table {\n  width: 100%;\n  border-collapse: collapse;\n  white-space: nowrap;\n}\n\n.dmap-table thead th {\n  font-size: 13.125px;\n  font-weight: 600;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: #8b99b4;\n  text-align: left;\n  padding: 13.75px 20px;\n  background: #f7f9fd;\n  border-bottom: 1px solid #dee4f0;\n  position: sticky;\n  top: 0;\n}\n\n.dmap-table thead th:last-child {\n  text-align: right;\n}\n\n.dmap-table tbody td {\n  padding: 16.25px 20px;\n  border-bottom: 1px solid #eaeff7;\n  font-size: 16.875px;\n  vertical-align: middle;\n  color: #0f172a;\n}\n\n.dmap-table tbody tr {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.dmap-table tbody tr:hover {\n  background: #f7f9fd;\n}\n\n.dmap-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.dmap-label {\n  white-space: normal;\n  min-width: 350px;\n  font-weight: 500;\n  color: #0f172a;\n  vertical-align: middle;\n}\n\n.dmap-label .incyia-desc,\n.dmap-label .incyia-desc--primary {\n  display: block;\n  -webkit-line-clamp: unset;\n  line-clamp: unset;\n  -webkit-box-orient: unset;\n  overflow: visible;\n  max-width: none;\n  color: #0f172a;\n  font-weight: 500;\n  font-size: 16.875px !important;\n  line-height: 1.45;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.dmap-table tbody tr:hover .dmap-label,\n.dmap-table tbody tr:hover .dmap-label .incyia-desc,\n.dmap-table tbody tr:hover .dmap-label .incyia-desc--primary {\n  background: transparent;\n  color: #0f172a;\n  text-decoration: none;\n}\n\n.dmap-mono {\n  font-size: 16.875px;\n  color: #0f172a;\n}\n\n.dmap-table td:nth-child(2) .dmap-mono {\n  font-size: 15.625px;\n}\n\n.dmap-map-cell {\n  display: flex;\n  align-items: center;\n  gap: 11.25px;\n  min-width: 212px;\n}\n\n.dmap-map-frac {\n  font-size: 15px;\n  color: #5b6b87;\n}\n\n.dmap-bar-track--sm {\n  width: 110px;\n  margin-top: 0;\n  flex: none;\n}\n\n.dmap-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 37.5px;\n  padding: 0 12.5px;\n  border-radius: 10px;\n  border: 1px solid #dee4f0;\n  background: #fff;\n  box-shadow: none;\n  font-size: 15.625px;\n  font-weight: 500;\n  color: #0f172a;\n  cursor: pointer;\n  width: auto !important;\n  line-height: 1;\n  transition: background 0.14s, border-color 0.14s;\n}\n\n.dmap-btn:hover {\n  background: #f7f9fd;\n  border-color: #8b99b4;\n}\n\n.dmap-pager {\n  display: flex;\n  align-items: center;\n  gap: 12.5px;\n  padding: 15px 20px;\n  border-top: 1px solid #eaeff7;\n  flex-wrap: wrap;\n}\n\n.dmap-pager-info {\n  margin-left: 0;\n  font-size: 15.625px;\n  color: #5b6b87;\n}\n\n.dmap-pager .dmap-btn {\n  margin-left: auto;\n}\n\n.dmap-empty {\n  padding: 50px 20px;\n  text-align: center;\n  color: #8b99b4;\n  font-size: 16.875px;\n}\n\n@media (max-width: 1100px) {\n  .dmap-kpi-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 700px) {\n  .dmap-kpi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dmap-count-note {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
